import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { RevenueItemService } from 'src/app/revenue/shared/revenue-items/revenue-item.service';
import { EcomCategoryDto } from '../shared/dto/ecom-category.dto';
import { EcomItemDto } from '../shared/dto/ecom-item.dto';
import { EcomService } from '../shared/ecom.service';

@Component({
  selector: 'wl-ecom-item-edit-general',
  templateUrl: './ecom-item-edit-general.component.html',
  styleUrls: ['./ecom-item-edit-general.component.less'],
    standalone: false
})
export class EComItemEditGeneralComponent implements OnInit, OnChanges {
  @Input() eCommerceItem: EcomItemDto;
  revenueItems: SelectItem[] = [];
  ecommerceTypes: SelectItem[] = [];
  categories: Array<EcomCategoryDto>;
  filteredCategories: Array<EcomCategoryDto> = [];
  selectedCategories: Array<EcomCategoryDto> = [];
  // to determine if the item got loaded before the categories.
  needCategories = false;
  enableMemberPrice = false;

  constructor(private _revenueItemService: RevenueItemService, private _ecomService: EcomService) {}

  ngOnInit() {
    this._revenueItemService.getAllRevenueItems().then((data) => {
      this.revenueItems = data
        .filter((ri) => !ri.Inactive)
        .map<SelectItem>((x) => {
          return { label: x.ItemName, value: x.ItemNum };
        });
    });

    this._ecomService.GetItemTypes().then((data) => {
      this.ecommerceTypes = data.Result.map<SelectItem>((x) => {
        return { label: x.Ecom_ItemType, value: x.Ecom_ItemTypeID };
      });
    });

    this._ecomService.GetCategories().then((data) => {
      this.categories = data?.Result;
      if (this.needCategories) {
        this.selectedCategories = this.categories.filter((x) => this.eCommerceItem?.Categories?.some((c) => c == x.EcomCategoryId));
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.eCommerceItem) {
      if (this.categories?.length) {
        this.selectedCategories = this.categories.filter((x) => this.eCommerceItem?.Categories?.some((c) => c == x.EcomCategoryId));
      } else {
        this.needCategories = true;
      }

      if (this.eCommerceItem.MemberPrice != null && this.eCommerceItem.MemberPrice != this.eCommerceItem.Price) {
        this.enableMemberPrice = true;
      } else {
        this.enableMemberPrice = false;
      }
    }
  }

  public filterCategories(event: any) {
    this.filteredCategories = this.categories.filter(
      (x) =>
        x.EcomCategory1.toLowerCase().includes(event.query.toLowerCase()) &&
        !this.filteredCategories?.some((c) => c.EcomCategoryId == x.EcomCategoryId)
    );
  }

  public catagorySelected() {
    this.eCommerceItem.Categories = this.selectedCategories?.map((x) => x.EcomCategoryId) as [];
  }

  public setMemberPrice() {
    if (!this.enableMemberPrice) {
      this.eCommerceItem.MemberPrice = this.eCommerceItem.Price;
    }
  }
}
